// 🔥 Firebase Core (compat + modular mixed setup)
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';

import { initializeFirestore, memoryLocalCache } from 'firebase/firestore';

import { getStorage } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAuth, signInWithCustomToken } from 'firebase/auth';

import { getFirebaseToken } from '../redux/slices/user/userDetails';

//
// 🔥 Firebase App Init
//


const app =
  firebase.apps.length === 0
    ? firebase.initializeApp({
        apiKey: 'AIzaSyAUM6p8FYYP1QCpc4BUmxa5mihUho1_5yA',
        authDomain: 'lomavis-prod-eu.firebaseapp.com',
        databaseURL:
          'https://lomavis-prod-eu-default-rtdb.europe-west1.firebasedatabase.app',
        projectId: 'lomavis-prod-eu',
        storageBucket: 'lomavis-prod-eu.appspot.com',
        messagingSenderId: '783431336947',
        appId: '1:783431336947:web:f87fd1a25204bc8cffc886'
      }
      // { // apiKey: 'AIzaSyA9x47AgH9FViXt5ZSAOpo6D5majH3lRiQ', // authDomain: 'lomavis-development.firebaseapp.com', // databaseURL: // 'https://lomavis-development-default-rtdb.europe-west1.firebasedatabase.app', // projectId: 'lomavis-development', // storageBucket: 'lomavis-development.appspot.com', // messagingSenderId: '951363988806', // appId: '1:951363988806:web:91a98779c451b8b5d18947' // }
      )
    : firebase.app();

//
// 🔥 App Check
//
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LfV38IgAAAAAOdesgwnW7iA5EEzU3Vd3coVtH2f'),
  isTokenAutoRefreshEnabled: true
});
// '6LeAhKQgAAAAAAfJ9VZzBq0FJwewfDdY4kmoijRI'

//
// 🚨🔥 FIRESTORE CORPORATE FIREWALL + CACHE 🔥🚨
//
// ✔ funktioniert in Firmen-Netzwerken (long polling)
// ✔ kein IndexedDB-/localStorage-Ballast im Browser
//
// No persistent cache, deliberately:
//
// 1. Every call site uses getDocs (see redux/slices/analytics/plotsData.ts —
//    the app's only Firestore consumer). The SDK implements getDocs as a
//    snapshot listener with waitForSyncWhenOnline, so while online it always
//    waits for the server snapshot. A persistent cache saves no reads and
//    cannot make a repeat visit paint faster — that needs onSnapshot.
// 2. persistentLocalCache costs a ~40MB IndexedDB LRU budget plus an
//    IndexedDB open/migration on every cold start, and its multi-tab manager
//    kept shared state in localStorage — a full store killed the client with
//    "INTERNAL UNHANDLED ERROR: The quota has been exceeded".
//
// The only thing given up is offline getDocs, on a page that needs the network
// for its REST analytics anyway. Revisit this if onSnapshot listeners or
// offline writes ever land — that is when persistence starts paying for
// itself. App-side localStorage caches still need to stay inside a budget so
// they don't starve Firebase Auth — see redux/slices/cache/locationCache.ts.
export const firestore = initializeFirestore(app, {
  // Corporate firewall safe
  experimentalForceLongPolling: true,

  localCache: memoryLocalCache()
} as any);

//
// 🔥 Realtime DB (kein Fix nötig)
//
export const database = firebase.database();

//
// 🔥 Storage
//
export const storage = getStorage(app);

//
// 🔥 Auth
//
const auth = getAuth();

getFirebaseToken()
  .then((token) => signInWithCustomToken(auth, token))
  .then((userCredential) => {
    console.log('Firebase login successful', userCredential.user?.uid);
  })
  .catch((error) => {
    console.error('Firebase auth error:', error);
  });
